<div class="kpi-container" [ngClass]="{'clickable': isClickable()}" matRipple [matRippleDisabled]="!isClickable()" [matTooltip]="tooltip()"
     (click)="isClickable() && clicked.emit()">
    <div class="kpi-content">
        <div class="title" [class.g-loader-s]="isLoading()">
          <span
                  class="data-l-medium count">{{ Utils.humanizeNumber(languageService.texts.general.not_available, count()) }}</span>
            <span #titleSpan class="data-m text"
                  [matTooltip]="title()"
                  [matTooltipDisabled]="!Utils.isTextOverflowing(titleSpan)"
            >{{ title() }} </span>

        </div>
        <div class="sub-title" [class.g-loader-xs]="isLoading()">
            <app-ui-icon-status class="status-icon" [status]="status()"></app-ui-icon-status>
            <span class="data-s text">{{ subTitle() }}</span>
        </div>
    </div>

</div>
